import type { TMessages } from '@/types/TMessages'

export const messages = { allServices: 'Все финансовые инструменты' } satisfies TMessages
